<script>
  import Page from '@components/page.svelte'
  import Table from '@components/table'
  import Button from '@components/buttons/button.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import { router } from '@inertiajs/svelte'
  import { CirclePlus, EllipsisVertical, Pencil, Trash2, Check, X } from 'lucide-svelte'

  let { site_pages = [] } = $props()

  function deletePage(page) {
    if (!window.confirm(`Are you sure you want to delete "${page.title}"?`)) return
    router.delete(`/admin/site_pages/${page.id}`)
  }
</script>

<Page title="Site Pages" subtitle="Manage site pages and content" links={[{ text: "Admin", href: "/admin" }]}>

  {#snippet buttons()}
    <Button text="New page" path="/admin/site_pages/new" Icon={CirclePlus} />
  {/snippet}

  <Table.Root empty={site_pages.length === 0} emptyMessage="No site pages found">
    <Table.Head>
      <Table.Header width="30%">Title</Table.Header>
      <Table.Header width="25%">Slug</Table.Header>
      <Table.Header width="15%" align="center">On Signup</Table.Header>
      <Table.Header width="20%">Preview</Table.Header>
      <Table.Header width="10%" align="center">Actions</Table.Header>
    </Table.Head>

    <Table.Body>
      {#each site_pages as page (page.id)}
        <Table.Row>
          <Table.Cell width="30%">
            <Button variant="link" text={page.title} path={`/admin/site_pages/${page.id}/edit`} />
          </Table.Cell>
          <Table.Cell width="25%">
            <span class="text-gray-500 font-mono text-xs">{page.slug}</span>
          </Table.Cell>
          <Table.Cell width="15%" align="center">
            {#if page.show_on_signup}
              <Check size={16} class="text-green-500 mx-auto" />
            {:else}
              <X size={16} class="text-gray-300 mx-auto" />
            {/if}
          </Table.Cell>
          <Table.Cell width="20%">
            <div class="max-w-48 truncate text-gray-400 text-xs">{page.content?.text || '—'}</div>
          </Table.Cell>
          <Table.Cell width="10%" align="center">
            <Dropdown buttonProps={{ variant: "naked", Icon: EllipsisVertical }} showTriggerButton={false} width="16rem">
              {#snippet contents(item)}
                {@render item({ text: "Edit", icon: Pencil, href: `/admin/site_pages/${page.id}/edit` })}
                {@render item({ text: "Delete", icon: Trash2, onSelect: () => deletePage(page) })}
              {/snippet}
            </Dropdown>
          </Table.Cell>
        </Table.Row>
      {/each}
    </Table.Body>
  </Table.Root>

</Page>
